import React, { useContext, useState } from 'react';
import PropTypes from "prop-types";
import OccurrenceSummary from "./OccurrenceSummary";
import ReschedulerModal from "./ReschedulerModal";
import RescheduledSummary from "./RescheduledSummary";
import ReschedulerFormProvider, { ReschedulerFormContext } from "./ReschedulerFormProvider";
import ModalToggleButton from "../../../Inputs/ModalToggleButton";
import ActionButton from "../../../Buttons/ActionButton";


const OccurrenceInputRow = ({
    bookingConfig,
    occurrence,
    rescheduledOccurrences,
    onReschedule
}) => {

    const maxSlotsExceeded = occurrence.verification_errors?.max_slots_exceeded ?? null;

    return (
        <ReschedulerFormProvider
            bookingConfig={bookingConfig}
            occurrence={occurrence}
            rescheduledOccurrences={rescheduledOccurrences}
            onReschedule={onReschedule}
        >
            <div className="grid-x">
                <div className="cell small-10">
                    <OccurrenceSummary/>
                </div>

                {(!!maxSlotsExceeded) && (
                    <div className="button-group margin-0 padding-0">
                        <ActionButton
                            icon="fa-ban"
                            className="micro margin-bottom-0"
                            isDisabled={true}
                            tooltip={"This occurrence can't be scheduled because: " + Object.values(maxSlotsExceeded)[0] ?? ''}
                        />
                    </div>
                )}

                {(!maxSlotsExceeded) && (
                    <div className="cell small-2 text-right">
                        <ModalToggleButton
                            icon="fa-pencil"
                            className="primary micro margin-bottom-0"
                            modalContent={(isOpen, setClosed) =>
                                <ReschedulerModal
                                    isExpanded={isOpen}
                                    onClose={() => setClosed()}
                                />
                            }
                        />
                    </div>
                )}
            </div>

            <RescheduledSummary/>

        </ReschedulerFormProvider>
    );
};

OccurrenceInputRow.propTypes = {
    occurrence: PropTypes.object
};

OccurrenceInputRow.defaultProps = {};

export default OccurrenceInputRow;
